export default __webpack_public_path__ + "static/media/Ecoli-Transparent-1.707ad2fd.png";